import React from "react";
import { useMediaQuery } from "react-responsive";

function ContactPage() {
  const isMonitor = useMediaQuery({ query: "(max-width: 1760px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1500px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1200px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 900px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });

  const handleButtonClick = () => {
    window.location.href = "https://cerclex.com/";
  };

  return (
    <div  data-aos="flip-up"
      className={`cover white ${
        isTablet ? "p-2" : "p-4"
      } valign-wrapper justify-center column`}
      style={{
        width: isLaptop ? "" : "85%",
        margin: "auto",
        marginTop: isSmallLaptop ? "2rem" : "4rem",
      }}
    >
      <h3
        className="valign-wrapper justify-center"
        style={{
          fontSize: isTablet
            ? "18px"
            : isSmallLaptop
            ? "25px"
            : isMonitor
            ? "32px"
            : "35px",
        }}
      >
        Ready to Transform Your Scrap Material Management?
      </h3>
      <div className={`flex  ${isMobile?"full-width column":"gap-2"}`}>
        <button
          className={`pointer cercle-purple-text mt-2 ${
            isTablet ? "font-16px" : "font-18px"
          }`}
          style={{
            padding: isTablet ? "7px 15px" : "15px 38px",
            border: "1px solid #6f2da8",
            borderRadius: "50px",
          }}
        >
          Request a Demo
        </button>
        <button
          className={`pointer white-text mt-2 font-18px`}
          style={{
            padding: isTablet ? "10px 15px" : "15px 38px",
            borderRadius: "50px",
            backgroundImage:
              "linear-gradient(to right,rgba(65, 4, 117, 1), rgba(100, 26, 164, 1))",
          }}
          onClick={handleButtonClick}
        >
          Join Cercle X Now
        </button>
      </div>
    </div>
  );
}

export default ContactPage;
